import React from 'react';

/**
 * Study recommendation callout card.
 */
export default function StudyRecommendation({ recommendation }) {
  if (!recommendation.domain) return null;

  const { domain, reason } = recommendation;

  return (
    <div className="bg-blue-900/20 border border-blue-700/30 rounded-xl p-5">
      <div className="flex items-start gap-3">
        <span className="text-2xl">💡</span>
        <div>
          <h3 className="text-blue-300 font-medium mb-1">Today's Focus</h3>
          <p className="text-gray-300 text-sm">
            Focus on <strong style={{ color: domain.color }}>{domain.name}</strong> today
            — your readiness is <strong>{domain.readiness}%</strong> in a domain
            worth <strong>{Math.round(domain.weight * 100)}%</strong> of the exam.
          </p>
          <p className="text-xs text-gray-500 mt-2">{reason}</p>
        </div>
      </div>
    </div>
  );
}
